<template>
  <button
    type="button"
    class="gs-checkout-layout-option"
    :class="{ 'is-active': isActiveOption }"
    :disabled="option.coming_soon || option.is_disabled"
    :aria-pressed="isActiveOption ? 'true' : 'false'"
    @click="updateActiveOption"
  >
      <div class="gs-checkout-layout-option__body">
        <div class="gs-checkout-layout-option__sequence">
          <div
            v-for="img in option.svg"
            :key="img"
            class="gs-checkout-layout-option__screen"
          >
            <img
              :class="{ 'is-password': img.includes('Password') }"
              :src="require(`@/assets/images/checkout/${img}.png`)"
              :alt="camelCaseToSentence(img)"
            />
            <p
              v-if="option.label === undefined"
              class="gs-checkout-layout-option__screen-label"
            >
              {{ camelCaseToSentence(img) }}
            </p>
          </div>
        </div>
        <p v-if="option.label !== undefined" class="gs-checkout-layout-option__label">
          {{ option.label }}
        </p>
      </div>
  </button>
</template>

<script>
export default {
  name: 'CheckoutRadioButton',
  model: {
    prop: 'activeOption',
    event: 'onUpdateOption',
  },

  props: ['option', 'activeOption'],

  computed: {
    isActiveOption() {
      return this.activeOption === this.option.id;
    },
  },

  methods: {
    updateActiveOption() {
      if (!this.option.coming_soon && !this.option.is_disabled) {
        this.$emit('onUpdateOption', this.option.id);
      }
    },

    camelCaseToSentence(imgName) {
      const result = imgName.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
  },
};
</script>

<style>
.gs-checkout-layout-option {
  width: 100%;
  min-height: 144px;
  padding: 16px;
  color: var(--gs-foreground, #182230);
  text-align: left;
  background: #fff;
  border: 1px solid var(--gs-border, #e2e8f0);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color .16s ease, box-shadow .16s ease, transform .16s ease;
}

.gs-checkout-layout-option:hover:not(:disabled) {
  border-color: var(--gs-active-border, #93c5fd);
  transform: translateY(-1px);
}

.gs-checkout-layout-option:focus-visible {
  outline: none;
  box-shadow: var(--gs-active-shadow, 0 0 0 3px rgba(37, 99, 235, .14));
}

.gs-checkout-layout-option.is-active {
  background: var(--gs-active-soft, #eff6ff);
  border-color: var(--gs-active, #2563eb);
  box-shadow: 0 0 0 1px var(--gs-active, #2563eb);
}

.gs-checkout-layout-option:disabled {
  cursor: not-allowed;
  opacity: .55;
}

.gs-checkout-layout-option__body {
  display: grid;
  height: 100%;
  place-items: center;
}

.gs-checkout-layout-option__sequence {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.gs-checkout-layout-option__screen {
  display: grid;
  width: 66px;
  gap: 6px;
  place-items: center;
}

.gs-checkout-layout-option__screen img {
  width: 58px;
  height: 72px;
  object-fit: contain;
  border: 1px solid transparent;
  border-radius: 7px;
}

.gs-checkout-layout-option__screen img.is-password {
  border-color: var(--gs-danger-border, #fecaca);
}

.gs-checkout-layout-option__screen-label,
.gs-checkout-layout-option__label {
  margin: 0;
  color: inherit;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
}

.gs-checkout-layout-option__label {
  margin-top: 10px;
  font-size: 12px;
}
</style>
